<template>
  <v-container fluid id="tract-settings">
    <v-row dense>
      <v-col cols="12">
        <material-card
          color="primary"
          full-width
          :title="$t('tractSettings')"
        >
          <v-tabs v-model="tab" show-arrows touchless>
            <v-tab>
              <span>{{ $t('tractTypes') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('harvestTypes') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('loggingMethods') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('accessTags') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('timberCategories') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('conversions') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('landownerTypes') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('mitigation') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('bidCostTypes') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('visitTypes') }}</span>
            </v-tab>

            <v-tab>
              <span>{{ $t('tractHud') }}</span>
            </v-tab>
          </v-tabs>

          <v-window v-model="tab">
            <v-window-item>
              <TractTypeSettings/>
            </v-window-item>

            <v-window-item>
              <HarvestTypeSettings/>
            </v-window-item>

            <v-window-item>
              <LoggingMethodSettings/>
            </v-window-item>

            <v-window-item>
              <AccessTagSettings/>
            </v-window-item>

            <v-window-item>
              <TimberCategorySettings/>
            </v-window-item>

            <v-window-item>
              <ConversionSettings/>
            </v-window-item>

            <v-window-item>
              <LandownerTypeSettings/>
            </v-window-item>

            <v-window-item>
              <MitigationGroupSettings/>
              <v-divider/>
              <MitigationHabitatSettings/>
              <v-divider/>
              <DueDiligenceExemptionSettings/>
            </v-window-item>

            <v-window-item>
              <BidCostTypeSettings/>
            </v-window-item>

            <v-window-item>
              <TractVisitTypeSettings/>
            </v-window-item>

            <v-window-item>
              <TractHudSettings/>
            </v-window-item>

          </v-window>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TractSettings',

  components: {
    TractTypeSettings: () => import('@/components/settings-components/tract-settings/tract-type/TractTypeSettings.vue'),
    HarvestTypeSettings: () => import('@/components/settings-components/tract-settings/harvest-type/HarvestTypeSettings.vue'),
    LoggingMethodSettings: () => import('@/components/settings-components/tract-settings/logging-method/LoggingMethodSettings.vue'),
    AccessTagSettings: () => import('@/components/settings-components/tract-settings/access-tag/AccessTagSettings.vue'),
    TimberCategorySettings: () => import('@/components/settings-components/bid-settings/TimberCategorySettings.vue'),
    ConversionSettings: () => import('@/components/settings-components/bid-settings/ConversionSettings.vue'),
    LandownerTypeSettings: () => import('@/components/settings-components/bid-settings/LandownerTypeSettings.vue'),
    MitigationGroupSettings: () => import('@/components/settings-components/tract-settings/mitigation-group/MitigationGroupSettings.vue'),
    MitigationHabitatSettings: () => import('@/components/settings-components/tract-settings/mitigation-habitat/MitigationHabitatSettings.vue'),
    DueDiligenceExemptionSettings: () => import('@/components/settings-components/tract-settings/due-diligence-exemption/DueDiligenceExemptionSettings.vue'),
    BidCostTypeSettings: () => import('@/components/settings-components/bid-settings/BidCostTypeSettings.vue'),
    TractVisitTypeSettings: () => import('@/components/settings-components/tract-settings/tract-visit-type/TractVisitTypeSettings.vue'),
    TractHudSettings: () => import('@/components/settings-components/tract-settings/tract-hud/TractHudSettings.vue')
  },

  data: () => ({
    tab: 0
  })
}
</script>
